export const ACTION_TYPE_SUCCESS = "SUCCESS";
export const ACTION_TYPE_ERROR = "ERROR";
export const ACTION_TYPE_WARNING = "WARNING";
export const ACTION_TYPE_LOADING = "LOADING";
